import DateRangeInput from './date-range-input';

export default DateRangeInput;
